import MainTitle from '../MainTitle/MainTitle';
import styles from './PrivacyPolicy.module.css';
import { FormattedMessage } from 'react-intl';

function PrivacyPolicy() {
  return (
    <section className={styles.privacySection} id="privacyPolicyId">
      <div className={styles.containerCustom}>
        <MainTitle
          title={<FormattedMessage id="privacyPolicy.title" defaultMessage="Privacy Policy" />}
          subTitleLine={
            <FormattedMessage
              id="privacyPolicy.subtitle"
              defaultMessage="Your privacy is important to us. Learn how we collect, use, and protect your personal information."
            />
          }
        />

        <div className={styles.privacyContainer}>
          <div className={styles.privacyCategory}>
            <h3 className={styles.categoryTitle}>
              <FormattedMessage
                id="privacyPolicy.dataCollection.title"
                defaultMessage="Data Collection"
              />
            </h3>
            <div className={styles.policyList}>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataCollection.point1"
                    defaultMessage="We collect personal information you provide when creating an account, including name, email, and contact details."
                  />
                </p>
              </div>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataCollection.point2"
                    defaultMessage="Payment information is securely processed through encrypted third-party payment processors."
                  />
                </p>
              </div>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataCollection.point3"
                    defaultMessage="We automatically collect usage data to improve our platform and user experience."
                  />
                </p>
              </div>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataCollection.point4"
                    defaultMessage="Location data may be collected to facilitate local rentals and deliveries."
                  />
                </p>
              </div>
            </div>
          </div>

          <div className={styles.privacyCategory}>
            <h3 className={styles.categoryTitle}>
              <FormattedMessage
                id="privacyPolicy.dataProtection.title"
                defaultMessage="Data Protection"
              />
            </h3>
            <div className={styles.policyList}>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataProtection.point1"
                    defaultMessage="All personal data is encrypted and stored securely using industry-standard security measures."
                  />
                </p>
              </div>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataProtection.point2"
                    defaultMessage="We never sell or share your personal information with third parties without your explicit consent."
                  />
                </p>
              </div>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataProtection.point3"
                    defaultMessage="You have the right to access, modify, or delete your personal data at any time."
                  />
                </p>
              </div>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataProtection.point4"
                    defaultMessage="We comply with GDPR and other applicable privacy regulations to protect your rights."
                  />
                </p>
              </div>
              <div className={styles.policyItem}>
                <div className={styles.policyBullet}></div>
                <p className={styles.policyText}>
                  <FormattedMessage
                    id="privacyPolicy.dataProtection.point5"
                    defaultMessage="Regular security audits ensure your data remains protected against unauthorized access."
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
